module.exports = __webpack_public_path__ + "img/type_FIRE.34db28a1.png";